import React from "react";
import i18next from "i18next";

export default function CustomNoDataOverLay() {
    return (
      <div className="h-full flex items-center justify-center font-bold">
        {i18next.t("common.message.no_data_display")}
      </div>
    );
  }